"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistributionViewPure = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var connected_react_router_1 = require("connected-react-router");
var sok_ui_1 = require("@caddigital/sok-ui");
var react_router_dom_1 = require("react-router-dom");
var WizardActions = require("@caddigital/sok-reducers/lib/actions/distribution/wizard");
var FilesActions = require("@caddigital/sok-reducers/lib/actions/files");
var ProjectActions = require("@caddigital/sok-reducers/lib/actions/projects");
var DistributionListActions = require("@caddigital/sok-reducers/lib/actions/distribution/list");
var ConfirmDialog_1 = require("components/modals/ConfirmDialog");
var Types = require("types");
var DistributionWizard_1 = require("components/sidemenus/DistributionWizard");
var DistributionEdit_1 = require("components/sidemenus/DistributionEdit");
var SearchBar_1 = require("components/SearchBar");
var ListContainer_1 = require("./ListContainer");
var Tools_1 = require("./Tools");
var translate_1 = require("utils/translate");
require("./style.scss");
var ProjectSelector_1 = require("components/ProjectSelector");
var mapStateToProps = function (_a) {
    var distribution = _a.distribution, cart = _a.cart;
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        wizard: distribution.wizard,
        cartSelectionsLength: cart.data.items.length,
        savingStatus: distribution.list.savingStatus,
        selected: distribution.list.selected,
        confirmDialogToggled: distribution.list.deleteDialogToggled,
        selectedLanguage: selectedLanguage
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    toggleWizard: function () { return dispatch(WizardActions.openCreateMenu()); },
    toggleDelete: function (selected) {
        dispatch(DistributionListActions.deleteDistributionsRequest(selected));
    },
    selectItem: function (ids) { return function () {
        return dispatch(DistributionListActions.selectItems(ids));
    }; },
    unselectItem: function (ids) { return function () {
        return dispatch(DistributionListActions.unselectItems(ids));
    }; },
    toggleEdit: function (item) { return function () {
        return dispatch(WizardActions.openEditMenu(item));
    }; },
    fetchDistributionList: function (project) { return function () {
        return dispatch(DistributionListActions.fetchDistributionListRequest(project));
    }; },
    onFetchProjects: function () {
        return dispatch(ProjectActions.fetchProjects({
            limit: 6,
            order: 'DESC',
            orderBy: 'visitedAt'
        }));
    },
    onSearchChange: function (_a) {
        var value = _a.target.value;
        return dispatch(DistributionListActions.setSearchString(value));
    },
    onPaginationChange: function (offset, limit) {
        dispatch(DistributionListActions.setLimit(limit));
        dispatch(DistributionListActions.setOffset(offset));
    },
    setSearchString: function (searchString) {
        return dispatch(DistributionListActions.setSearchString(searchString));
    },
    clearState: function () { return dispatch(DistributionListActions.clear()); },
    navigateToProject: function (lang, project) {
        dispatch(FilesActions.resetSortOptionsAction());
        dispatch(FilesActions.resetSearchOptionsAction());
        dispatch((0, connected_react_router_1.push)("/".concat(lang, "/projects/").concat(project.id, "/distribution")));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var NAME_AND_DESCRIPTION_MAX_LENGTH = 100;
var DistributionViewPure = function (props) { return (React.createElement("div", { className: 'content-wrapper-content' },
    React.createElement("div", { className: 'distribution-view' },
        React.createElement("main", { className: 'content' },
            React.createElement(sok_ui_1.BreadCrumb, null,
                React.createElement(react_router_dom_1.Link, { to: "/".concat((0, translate_1.getLanguage)(), "/projects/").concat(props.currentProject.id) }, props.currentProject.name),
                React.createElement("span", null, (0, translation_1.getLocalization)('breadcrumb/projectname/distribution'))),
            React.createElement(sok_ui_1.Grid.Row, { className: "sok-search-bar-content" },
                React.createElement(sok_ui_1.Grid.Column, { extraSmall: 12 },
                    React.createElement(ProjectSelector_1.ProjectSelector, { navigateToProject: props.navigateToProject }),
                    React.createElement(SearchBar_1.SearchBar, { setSearchString: props.setSearchString, placeHolder: (0, translation_1.getLocalization)('userfront/distribution/search') }))),
            React.createElement(Tools_1.Tools, __assign({}, props, { projectUUID: props.currentProject.uuid, toggleDelete: function () { return props.setIsOpen(true); } })),
            React.createElement(sok_ui_1.RequestStatusBox, { status: props.savingStatus, statusList: ['STANDBY', 'SAVING', 'SAVED', 'FAILED'] },
                React.createElement("span", null, (0, translation_1.getLocalization)('userfront/distribution/delete/deleting')),
                React.createElement("span", null, (0, translation_1.getLocalization)('userfront/distribution/delete/deleted')),
                React.createElement("span", null, (0, translation_1.getLocalization)('userfront/distribution/delete/error'))),
            React.createElement(ListContainer_1.ListContainer, { currentProject: props.currentProject }),
            React.createElement(DistributionWizard_1.DistributionWizard, { currentProject: props.currentProject, currentFolder: props.currentFolder, nameAndDescriptionMaxLength: NAME_AND_DESCRIPTION_MAX_LENGTH }),
            React.createElement(DistributionEdit_1.DistributionEdit, { currentProject: props.currentProject, currentFolder: props.currentFolder, nameAndDescriptionMaxLength: NAME_AND_DESCRIPTION_MAX_LENGTH }),
            React.createElement(ConfirmDialog_1.ConfirmDialog, { overlayClassName: 'generic-warning-confirmation-modal', isOpen: props.isOpen, close: function () { return props.setIsOpen(false); }, header: (0, translation_1.getLocalization)('genericWarningConfirmationModal/warning'), body: React.createElement(React.Fragment, null,
                    React.createElement(ConfirmDialog_1.Exclamation, null),
                    React.createElement("div", null,
                        React.createElement("div", { className: 'title please-confirm-text' },
                            React.createElement("h2", { className: "title" }, (0, translation_1.getLocalization)('genericWarningConfirmationModal/pleaseConfirm'))),
                        React.createElement("div", { className: 'text' },
                            React.createElement("p", null, (0, translation_1.getLocalization)('userfront/distribution/list/confirmation/header')),
                            React.createElement("p", null, (0, translation_1.getLocalization)('userfront/distribution/list/confirmation/description'))))), footer: React.createElement(React.Fragment, null,
                    React.createElement(sok_ui_1.Button, { color: 'red', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/confirm'), onClick: function () {
                            props.toggleDelete(props.selected);
                            props.setIsOpen(false);
                        } }),
                    React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/cancel'), onClick: function () { return props.setIsOpen(false); } })) }))))); };
exports.DistributionViewPure = DistributionViewPure;
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('isOpen', 'setIsOpen', false), (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        this.props.onFetchProjects();
        this.props.fetchDistributionList(this.props.currentProject)();
    },
    componentDidUpdate: function (previousProps) {
        if (this.props.currentProject.id !== previousProps.currentProject.id) {
            this.props.fetchDistributionList(this.props.currentProject)();
        }
    },
    componentWillUnmount: function () {
        this.props.clearState();
    }
}), recompose_1.pure);
exports.default = enhance(exports.DistributionViewPure);
